import script from "./SharedSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharedSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./SharedSpinner.vue?vue&type=style&index=0&id=0be5acc1&lang=scss"

const __exports__ = script;

export default __exports__